module.exports = __webpack_public_path__ + "img/ICONE_APS.359eb7bb.png";